import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import { NotFoundPage } from 'b2b-apps/shop/common/components/NotFoundPage';
import { withLoader } from 'b2b-apps/shop/common/hoc/withLoader';
import { ComponentType, Props } from './';

const Router: ComponentType = ({ routes }: Props): ReactElement => (
  <Switch>
    {routes}
    <Route component={NotFoundPage} key="not-found" />
  </Switch>
);

const ComposedRouter = withLoader((props: Props) => [props.contentEntriesMap], false)(Router);

export { ComposedRouter as Router };
